import { useState } from "react";
import { styles } from "../../../utils/styles/products-maintenance-styles";
import { useI18n } from "@/i18n/I18nProvider";
import { useFormik } from "formik";
import Box from "@mui/material/Box";
import dynamic from "next/dynamic";
import ProductMain from "@/components/products-revamp/product-main";
import DynamicFAQSection from "@/components/DynamicFAQSection";
import StepsRow from "@/components/steps-row";
import ApplyProduct from "@/components/products-revamp/product-apply";
import CalcPopup from "@/components/products-revamp/CalcPopup";
import { colors } from "@/utils/const";
import PgWithImgSection from "@/components/products-revamp/pg-with-img-section";
import Features from "@/components/products-revamp/features-section";
import SplitPgSection from "@/components/products-revamp/split-pg-section";
import { emptyProps, getProductPageData } from "@/services/get-product-data";
import {
  getLocalizedValue,
  getStaticTextByKey,
} from "@/utils/general-functions";
import { useSplitContentSections } from "@/hooks/product";
import { useProductLoanPackages } from "@/hooks/useProductLoanPackages";
import { getProductsText } from "../../../../locales/products";
const PageHead = dynamic(() => import("@/components/PageHead"));

export default function Index({
  heroData,
  contentWithImageData,
  featuresData,
  faqData,
  stepsData,
  staticTextData,
  mainData,
}) {
  const { t, locale } = useI18n();
  const products = getProductsText(locale);

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 5000)); // simulate delay
    actions.resetForm();
  };

  0;
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      email: "",
      phoneNumber: "",
      governorate: "",
      area: "",
      username: "",
      lastname: "",
      car_type: "",
      car_price: "",
    },
    onSubmit,
  });

  /*================ content with image =================*/
  const staticTexts = getStaticTextByKey(staticTextData?.data);
  const { fullNavySections, splitSections } =
    useSplitContentSections(contentWithImageData);
  //=============================////////////////
  const { targetProduct, data } = useProductLoanPackages(
    products.watercraft.id,
  );
  const [openCalc, setOpenCalc] = useState(false);
  return (
    <>
      <PageHead
        title={getLocalizedValue(mainData[0], "meta_title", locale)}
        description={getLocalizedValue(mainData[0], "meta_description", locale)}
        scripts={getLocalizedValue(mainData[0], "schema", locale)}
      />
      <Box sx={{ ...styles.container, overflow: "hidden" }}>
        {Array.isArray(heroData) && heroData.length > 0 && (
          <ProductMain
            heroData={heroData}
            staticTexts={staticTexts}
            onApplyClick={() => {
              const formSection = document.getElementById("apply-form");
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            onCalcClick={() => setOpenCalc((prev) => !prev)}
            onExploreMoreClick={() => {
              const formSection = document.getElementById(
                "watercraft-features",
              );
              if (formSection) {
                formSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            imgStyle={{ mt: locale === "ar" ? 3 : { xs: 5, xl: "auto" } }}
            headerH1={true}
            shadow={true}
          />
        )}
        {fullNavySections?.length > 0 &&
          fullNavySections.map((section, index) => (
            <PgWithImgSection
              key={section.id || index}
              img={section.img}
              alt={section.alt_img}
              title={section.title?.text?.[locale]}
              titleType={section.title?.type}
              paragraph={section.description?.text?.[locale]}
              paragraphType={section.description?.type}
              imgReverse={index === 0 || index === 2 ? false : true}
            />
          ))}

        <Box sx={{ position: "relative", bgcolor: colors.white }}>
          {splitSections?.length > 0 &&
            splitSections.map((section, index) => (
              <SplitPgSection
                key={section.id || index}
                img={section.img}
                alt={section.alt_img}
                title={section.title?.text?.[locale]}
                titleType={section.title?.type}
                paragraph={section.description?.text?.[locale]}
                paragraphType={section.description?.type}
                bgHeight={{
                  xs: "100%",
                  md: locale === "ar" ? "50%" : "52%",
                }}
              />
            ))}
          {/**features section */}

          {featuresData?.length > 0 &&
            featuresData.map((section, index) => (
              <Features
                key={section?.id || index}
                section={section}
                bgHeight={{ xs: "60%", sm: "65%", md: "40%", lg: "35%" }}
                id="watercraft-features"
              />
            ))}

          {/**faq section */}
          {faqData?.length > 0 &&
            faqData.map((section, index) => (
              <DynamicFAQSection
                key={section?.id || index}
                title={
                  staticTexts?.faqs_section_title?.value?.text[locale] || ""
                }
                items={section?.faqs}
                renderHTML={true}
                variantTitle="h2"
                variantQ="h3"
              />
            ))}
        </Box>
        {/**Steps section */}
        {stepsData?.length > 0 &&
          stepsData.map((section, index) => (
            <StepsRow
              key={section.id || index}
              title={section?.title?.text?.[locale]}
              titleType={section?.title?.type}
              subtitle={section?.description?.text?.[locale]}
              subtitleType={section?.description?.type}
              steps={section?.items}
            />
          ))}
        <ApplyProduct
          img={heroData[0]?.img}
          title={mainData[0]?.form_title.text[locale]}
          titleType={mainData[0]?.form_title?.type}
          description={mainData[0]?.form_desc.text[locale]}
          descType={mainData[0]?.form_desc?.type}
          formType="b"
          product="20"
          source={44}
          shadow={true}
        />

        {targetProduct?.hasPlan && (
          <CalcPopup
            open={openCalc}
            onClose={() => setOpenCalc(false)}
            data={data}
            max_amount={targetProduct?.maxLimit}
            price_label={products.watercraft.price}
            price_desc={products.watercraft.price_desc}
          />
        )}
      </Box>
    </>
  );
}

export async function getServerSideProps() {
  try {
    const data = await getProductPageData("watercraft");
    return { props: data };
  } catch {
    return { props: emptyProps };
  }
}
